import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { BehaviorSubject, Subject } from 'rxjs';

import { SubscriptionPlan, SubscriptionStatus } from '@vi-iot/client';

import { BookingSubscription, SearchHistoryItem, SearchType } from '@store';

@Injectable()
export class SearchService {
  search$: BehaviorSubject<SearchType> = new BehaviorSubject<SearchType>(undefined);
  activeSearch$: BehaviorSubject<string> = new BehaviorSubject<string>('gateway');
  onSearchHistoryEntryClicked$: Subject<SearchHistoryItem> = new Subject();

  errorSearchParams$: BehaviorSubject<SearchHistoryItem> = new BehaviorSubject<SearchHistoryItem>(
    undefined
  );
  gatewaySearchParams$: BehaviorSubject<SearchHistoryItem> = new BehaviorSubject<SearchHistoryItem>(
    undefined
  );
  userSearchParams$: BehaviorSubject<SearchHistoryItem> = new BehaviorSubject<SearchHistoryItem>(
    undefined
  );

  constructor(private translation: TranslateService) {}

  transformCountryCodeToUpperCase(code: string): string {
    const countryCode = code.split('_')[0].toUpperCase();
    const languageCode = code.split('_')[1];

    return languageCode ? countryCode + '_' + languageCode.toLowerCase() : countryCode;
  }

  getLeftDays(date: Date): string {
    const expirationDate = moment(date);
    const currentDate = moment();
    const leftDays = expirationDate.diff(currentDate, 'days');

    return leftDays === 1
      ? `${leftDays} ${this.translation.instant('+BOOKING.OVERVIEW.SUBSCRIPTION.DAY')}`
      : `${leftDays} ${this.translation.instant('+BOOKING.OVERVIEW.SUBSCRIPTION.DAYS')}`;
  }

  getBookingDateLabel(subscription: BookingSubscription): string {
    if (
      subscription.status?.toLowerCase() === SubscriptionStatus.active &&
      (subscription.plan === SubscriptionPlan.Plus || subscription.trial)
    ) {
      return '+USER_DETAILS.BOOKINGS.EXPIRES_AT';
    }
    if (subscription.status?.toLowerCase() === SubscriptionStatus.active) {
      return '+USER_DETAILS.BOOKINGS.RENEWAL';
    }

    return '+BOOKING.OVERVIEW.SUBSCRIPTION.EXPIRATION_DATE';
  }

  isCancellingPackagePossible(subscription: BookingSubscription): boolean {
    return (
      subscription.status?.toLowerCase() === SubscriptionStatus.active &&
      subscription.plan === SubscriptionPlan.Pro &&
      !subscription.trial
    );
  }
}
